import {ParamsModel} from '../../model'
export const initValues: ParamsModel = {
  id: '',
  tabla: '',
  codigo: '',
  nombreCorto: '',
  nombreLargo: '',
  tipoDato: '',
  estado: '',
  tablaPadre: '',
  codigoPadre: '',
}
